var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    attrs: {
      model: _vm.form,
      layout: "inline"
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("页面背景图")
    }
  }, [_c("a-upload", {
    attrs: {
      action: _vm.action,
      "list-type": "picture-card",
      "file-list": _vm.fileList,
      accept: "image/*",
      "before-upload": _vm.beforeUpload,
      data: {
        module: "dynamicControls"
      },
      showUploadList: {
        showRemoveIcon: true,
        showPreviewIcon: true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      }
    },
    on: {
      change: _vm.handleChange,
      preview: function ($event) {
        _vm.previewVisible = true;
      }
    }
  }, [_vm.fileList.length == 0 ? _c("div", [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(_vm._s(_vm.$t("上传")))])], 1) : _vm._e()])], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("页面主题色")
    }
  }, [_c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.themeColor
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.themeColor, "themeColor");
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("页面背景色")
    }
  }, [_c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.backgroundColor
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link",
      disabled: _vm.fileList.length ? true : false
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.backgroundColor, "backgroundColor");
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("页面标题颜色")
    }
  }, [_c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.titleColor
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.titleColor, "titleColor");
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _vm.$route.params.type != "DETAILS" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("页面标题")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("页面标题"),
      maxLength: 15
    },
    on: {
      change: _vm.handleBlurTrim
    },
    model: {
      value: _vm.form.pageTitle,
      callback: function ($$v) {
        _vm.$set(_vm.form, "pageTitle", $$v);
      },
      expression: "form.pageTitle"
    }
  })], 1) : _vm._e(), _vm.$route.params.type == "DETAILS" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("是否展示页面导航")
    }
  }, [_c("a-radio-group", {
    on: {
      change: function ($event) {
        return _vm.changeFun(false);
      }
    },
    model: {
      value: _vm.form.isDisplayNavigation,
      callback: function ($$v) {
        _vm.$set(_vm.form, "isDisplayNavigation", $$v);
      },
      expression: "form.isDisplayNavigation"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("是")) + " ")]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("否")) + " ")])], 1)], 1) : _vm._e(), _c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.form.pageDescription
    },
    on: {
      change: e => _vm.onChangePageLabel(e, "pageDescription")
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("添加页面说明")) + " ")])], 1), _vm.form.pageDescription ? _c("div", {
    staticStyle: {
      "margin-top": "10px",
      "font-weight": "700"
    }
  }, [_vm._v(_vm._s(_vm.$t("页面说明设置")))]) : _vm._e(), _vm.form.pageDescription ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选择位置")
    }
  }, [_c("a-radio-group", {
    on: {
      change: function ($event) {
        return _vm.changeFun(false);
      }
    },
    model: {
      value: _vm.form.pageDescriptionConfig.position,
      callback: function ($$v) {
        _vm.$set(_vm.form.pageDescriptionConfig, "position", $$v);
      },
      expression: "form.pageDescriptionConfig.position"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "top"
    }
  }, [_vm._v(_vm._s(_vm.$t("顶部")))]), _c("a-radio", {
    attrs: {
      value: "bottom"
    }
  }, [_vm._v(_vm._s(_vm.$t("底部")))])], 1)], 1) : _vm._e(), _vm.form.pageDescription ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("提示内容")
    }
  }, [_c("a-textarea", {
    attrs: {
      rows: 3,
      placeholder: _vm.$t("请输入") + "2-40" + _vm.$t("字符")
    },
    model: {
      value: _vm.form.pageDescriptionConfig.content,
      callback: function ($$v) {
        _vm.$set(_vm.form.pageDescriptionConfig, "content", $$v);
      },
      expression: "form.pageDescriptionConfig.content"
    }
  })], 1) : _vm._e(), _c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("a-checkbox", {
    attrs: {
      checked: _vm.form.pagePopUp
    },
    on: {
      change: e => _vm.onChangePageLabel(e, "pagePopUp")
    }
  }, [_vm._v(_vm._s(_vm.$t("添加页面弹窗")))])], 1), _vm.form.pagePopUp ? _c("div", {
    staticStyle: {
      "margin-top": "10px",
      "font-weight": "700"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("弹窗设置")) + "： "), _c("span", {
    staticStyle: {
      "font-weight": "400",
      color: "#999999"
    }
  }, [_vm._v("*" + _vm._s(_vm.$t("弹窗将在进入页面时展示")))])]) : _vm._e(), _vm.form.pagePopUp ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("弹窗位置")
    }
  }, [_c("a-radio-group", {
    on: {
      change: function ($event) {
        return _vm.changeFun(true);
      }
    },
    model: {
      value: _vm.form.pagePopUpConfig.popUpPosition,
      callback: function ($$v) {
        _vm.$set(_vm.form.pagePopUpConfig, "popUpPosition", $$v);
      },
      expression: "form.pagePopUpConfig.popUpPosition"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "central"
    }
  }, [_vm._v(_vm._s(_vm.$t("中部")))]), _c("a-radio", {
    attrs: {
      value: "bottom"
    }
  }, [_vm._v(_vm._s(_vm.$t("底部")))])], 1)], 1) : _vm._e(), _vm.form.pagePopUp && _vm.$route.params.type != "DETAILS" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("弹窗标题")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + "2-15" + _vm.$t("字符")
    },
    model: {
      value: _vm.form.pagePopUpConfig.popUpTitle,
      callback: function ($$v) {
        _vm.$set(_vm.form.pagePopUpConfig, "popUpTitle", $$v);
      },
      expression: "form.pagePopUpConfig.popUpTitle"
    }
  })], 1) : _vm._e(), _vm.form.pagePopUp && _vm.$route.params.type != "DETAILS" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("弹窗内容")
    }
  }, [_c("a-textarea", {
    attrs: {
      rows: 3,
      placeholder: _vm.$t("请输入") + "5-100" + _vm.$t("字符")
    },
    model: {
      value: _vm.form.pagePopUpConfig.popUpContent,
      callback: function ($$v) {
        _vm.$set(_vm.form.pagePopUpConfig, "popUpContent", $$v);
      },
      expression: "form.pagePopUpConfig.popUpContent"
    }
  })], 1) : _vm._e(), _vm.form.pagePopUp ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("按钮文案")
    }
  }, [_c("a-input", {
    attrs: {
      placeholder: _vm.$t("请输入") + "1-15" + _vm.$t("字符")
    },
    model: {
      value: _vm.form.pagePopUpConfig.buttonName,
      callback: function ($$v) {
        _vm.$set(_vm.form.pagePopUpConfig, "buttonName", $$v);
      },
      expression: "form.pagePopUpConfig.buttonName"
    }
  })], 1) : _vm._e(), _vm.form.pagePopUp ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("按钮事件")
    }
  }, [_c("a-select", {
    model: {
      value: _vm.form.pagePopUpConfig.buttonEvent,
      callback: function ($$v) {
        _vm.$set(_vm.form.pagePopUpConfig, "buttonEvent", $$v);
      },
      expression: "form.pagePopUpConfig.buttonEvent"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "close"
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭弹窗")))])], 1)], 1) : _vm._e()], 1), _c("a-button", {
    staticClass: "btnBox",
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.defaultFun
    }
  }, [_vm._v(_vm._s(_vm.$t("恢复默认设置")))]), _vm.colorShow ? _c("color-model", {
    ref: "colorRef",
    on: {
      cancel: function ($event) {
        _vm.colorShow = false;
      },
      ok: _vm.colorFun
    }
  }) : _vm._e(), _c("a-modal", {
    attrs: {
      visible: _vm.previewVisible,
      footer: null
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }, [_c("img", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      alt: "example",
      src: _vm.form.backgroundImage
    }
  })])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };